import { useEffect } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { useScreenContext } from "../Layout";
import resultInage from "../../assets/images/result.png";
import { useTranslation } from "react-i18next";

function LoadingResult() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: "book-list",
      progress: 91,
    }));
  });

  return (
    <div>
      <ConfettiExplosion />
      <h1 className="mb-4 mt-5 text-3xl font-semibold leading-tight tracking-normal text-gray-900 md:text-4xl">
        {t("result.headline.part_1")}{" "}
        <span className="font-bold text-blue-600">
          {t("result.headline.part_2")}
        </span>{" "}
        {t("result.headline.part_3")}
      </h1>
      <p className="font-light">{t("result.subheadline.part_1")}</p>
      <div className="px-10 py-5 ">
        <hr />
      </div>
      <p className="font-light">
        <span className="text-lg">🎧</span> {t("result.subheadline.part_2")}
      </p>
      <img
        className="mx-auto mt-10 max-w-sm px-10"
        alt="Chart showing your progress"
        src={resultInage}
      />
    </div>
  );
}

export default LoadingResult;
